// /connections — real route (was DEFERRED, see the removed comment in
// routes/agents.tsx). Unlike /agents, apps/web's original page.tsx had no
// separate client component to alias-mount unmodified — it was an async
// server component doing its own DB/SDK reads with two inline server
// actions. app/connections/client.tsx is a genuine rewrite into a pure
// client component (plain-fetch data against apps/server's new
// /api/connections* routes), so this route file just thin-mounts it, same
// shape as routes/agents-page.tsx.
import { createRoute } from '@tanstack/react-router';
import { ConnectionsClient } from '@/app/connections/client';
import { authedRoute } from './guards';

export const connectionsPageRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/connections',
  component: ConnectionsClient,
});
